import { z } from 'zod';

const CustomPageParameterZod = z
  .object({
    name: z.string().trim().min(1),
    valuePath: z.string().trim().min(1),
  })
  .strict();

const CustomPageZod = z
  .object({
    title: z.string().trim().min(1),
    url: z.string().trim().url(),
    route: z.string().trim().min(1).regex(/^\//),
    identifier: z
      .string()
      .trim()
      .min(1)
      .regex(/^[a-zA-Z0-9_-]*$/),
    mountFunction: z.string().trim().min(1),
    unmountFunction: z.string().trim().min(1),
    parameters: z.array(CustomPageParameterZod),
    conditions: z
      .object({
        useCaseTemplateIds: z.array(z.string().trim().min(1)).optional(),
        types: z.array(z.string().trim().min(1)).optional(),
      })
      .strict()
      .optional(),
  })
  .strict();

const DescriptorPreviewZod = z
  .object({
    enabled: z.boolean().optional(),
    defaultView: z.enum(['customView', 'yaml']).optional(),
  })
  .strict();

export const ConfigValidator = z.object({
  fe: z.object({
    editAndTest: z
      .object({
        descriptorPreview: DescriptorPreviewZod.optional(),
      })
      .strict()
      .optional(),
    customPages: z
      .object({
        systemPage: z.array(CustomPageZod).optional(),
        componentPage: z.array(CustomPageZod).optional(),
      })
      .strict()
      .optional(),
  }),
});

export type DescriptorPreviewConfig = z.infer<typeof DescriptorPreviewZod>;

export type ConfigSchema = z.infer<typeof ConfigValidator>;

export const defaultConfig: DeepPartial<ConfigSchema> = {
  fe: {
    editAndTest: {
      descriptorPreview: { enabled: false },
    },
  },
};

type DeepPartial<T> = {
  [P in keyof T]?: T[P] extends object ? DeepPartial<T[P]> : T[P];
};
